import type { CSSProperties, MouseEventHandler, ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export interface ButtonProps {
  children: ReactNode;
  variant?: ButtonVariant;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  loading?: boolean;
  icon?: IconName;
  iconEnd?: IconName;
  fullWidth?: boolean;
  type?: 'button' | 'submit';
  style?: CSSProperties;
  'aria-label'?: string;
}

/** The app's action button. Full width by default, 52 px tall, one primary action per screen. */
export function Button({
  children,
  variant = 'primary',
  onClick,
  disabled,
  loading,
  icon,
  iconEnd,
  fullWidth = true,
  type = 'button',
  style,
  ...rest
}: ButtonProps) {
  const off = Boolean(disabled || loading);
  return (
    <button
      type={type}
      disabled={off}
      onClick={onClick}
      aria-busy={loading || undefined}
      className={`fw-button fw-button--${variant}${fullWidth ? '' : ' fw-button--auto'}`}
      style={style}
      aria-label={rest['aria-label']}
    >
      {loading && <span className="fw-spinner" aria-hidden="true" />}
      {!loading && icon && <Icon name={icon} size={20} />}
      <span>{children}</span>
      {!loading && iconEnd && <Icon name={iconEnd} size={20} />}
    </button>
  );
}
